/**
 * ISO 3166-1 alpha-2 countries where Stripe Connect connected accounts can be created.
 * Source: https://docs.stripe.com/connect/accounts (Express and Custom availability lists).
 */
export const STRIPE_CONNECT_SUPPORTED_COUNTRY_CODES = [
  'AE',
  'AG',
  'AL',
  'AM',
  'AR',
  'AT',
  'AU',
  'BA',
  'BE',
  'BG',
  'BH',
  'BJ',
  'BN',
  'BO',
  'BS',
  'BW',
  'CA',
  'CH',
  'CI',
  'CL',
  'CO',
  'CR',
  'CY',
  'CZ',
  'DE',
  'DK',
  'DO',
  'EC',
  'EE',
  'EG',
  'ES',
  'ET',
  'FI',
  'FR',
  'GB',
  'GH',
  'GM',
  'GR',
  'GT',
  'GY',
  'HK',
  'HU',
  'IE',
  'IL',
  'IS',
  'IT',
  'JM',
  'JO',
  'JP',
  'KE',
  'KH',
  'KR',
  'KW',
  'LC',
  'LK',
  'LT',
  'LU',
  'LV',
  'MA',
  'MC',
  'MD',
  'MG',
  'MK',
  'MN',
  'MO',
  'MT',
  'MU',
  'MX',
  'NA',
  'NG',
  'NL',
  'NO',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PH',
  'PK',
  'PL',
  'PT',
  'PY',
  'QA',
  'RO',
  'RS',
  'RW',
  'SA',
  'SE',
  'SG',
  'SI',
  'SK',
  'SN',
  'SV',
  'TH',
  'TN',
  'TR',
  'TT',
  'TW',
  'TZ',
  'US',
  'UY',
  'UZ',
  'VN',
  'ZA',
] as const;

export type StripeConnectSupportedCountryCode =
  (typeof STRIPE_CONNECT_SUPPORTED_COUNTRY_CODES)[number];

const STRIPE_CONNECT_SUPPORTED_COUNTRY_SET = new Set<string>(
  STRIPE_CONNECT_SUPPORTED_COUNTRY_CODES,
);

/** True when the ISO country code can host a Stripe Connect account for lesson/club payments. */
export function isStripeConnectCountryCodeSupported(
  countryCode: string | null | undefined,
): boolean {
  if (!countryCode?.trim()) {
    return false;
  }
  return STRIPE_CONNECT_SUPPORTED_COUNTRY_SET.has(countryCode.trim().toUpperCase());
}
